import { Link } from "react-router";
import { useUserActions } from "@/hooks/useUserActions";

/**
 * Nav entry for Actions. The pill counts the user's own actions, so it starts
 * at zero and ticks up as findings are added from Trial News — including while
 * the Trial News drawer sits open over this nav.
 */
export function ActionsNavLabel() {
  const { count } = useUserActions();

  return (
    <Link to="actions" className="flex items-center justify-between gap-2">
      <span>Actions</span>
      {count > 0 && (
        <div
          className="bg-[#EBD1E0] text-[#73134A] rounded-full px-2 py-1 text-xs"
          data-testid="actions-nav-count"
        >
          {count}
        </div>
      )}
    </Link>
  );
}
